/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface TrackItDataTypeDoubleDto
 */
export interface TrackItDataTypeDoubleDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeDoubleDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataTypeDoubleDto
     */
    trackItId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeDoubleDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeDoubleDto
     */
    definition?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof TrackItDataTypeDoubleDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataTypeDoubleDto
     */
    readonly commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeDoubleDto
     */
    readonly lastComment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeDoubleDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataTypeDoubleDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeDoubleDto
     */
    $type?: TrackItDataTypeDoubleDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItDataTypeDoubleDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItDataTypeDoubleDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeDoubleDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItDataTypeDoubleDtoTypeEnum = typeof TrackItDataTypeDoubleDtoTypeEnum[keyof typeof TrackItDataTypeDoubleDtoTypeEnum];



/**
 * Check if a given object implements the TrackItDataTypeDoubleDto interface.
 */
export function instanceOfTrackItDataTypeDoubleDto(value?: unknown): value is TrackItDataTypeDoubleDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItDataTypeDoubleDtoTypeEnum)[0];
}

export function TrackItDataTypeDoubleDtoFromJSON(json: any): TrackItDataTypeDoubleDto {
    return TrackItDataTypeDoubleDtoFromJSONTyped(json, false);
}

export function TrackItDataTypeDoubleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItDataTypeDoubleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'trackItId': json['trackItId'] == null ? undefined : json['trackItId'],
        'name': json['name'] == null ? undefined : json['name'],
        'definition': json['definition'] == null ? undefined : json['definition'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'value': json['value'] == null ? undefined : json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItDataTypeDoubleDtoToJSON(value?: Omit<TrackItDataTypeDoubleDto, 'commentCount'|'lastComment'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'trackItId': value['trackItId'],
        'name': value['name'],
        'definition': value['definition'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'unit': value['unit'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

